module.exports = __webpack_public_path__ + "media/exterieur21h.387d63ee.mp4";